import React, { useState } from 'react';
import { ReactComponent as AdditionallyIcon } from '../../../../resource/AdditionallyIcon.svg';
import AdditionallyBody from '../AdditionallyBody/AdditionallyBody';
import Card from '../Card/Card';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';
import { useSelector } from 'react-redux';
import useLastCommentQuery from '../../queries/useLastCommentQuery';
import useStatusesQuery from '../../queries/useStatusesQuery';
import useDocsTopicsQuery from '../../queries/useDocsTopicsQuery';
import useDocsAppealTopicsQuery from '../../queries/useDocsAppealTopicsQuery';

const AdditionallyContainer = ({ form }) => {
  const [expanded, setExpanded] = useState(true);

  const { mode, documentId } = useSelector(documentDrawerSelector);

  const handleExpanded = () => {
    setExpanded(!expanded);
  };

  const { data: lastComment = [], isFetching } = useLastCommentQuery(
    documentId,
    {
      enabled: Boolean(mode === 'edit' && documentId),
    }
  );
  const { data: statuses = [], isFetching: isFetchingStatuses } =
    useStatusesQuery({
      enabled: Boolean(mode === 'edit'),
    });

  const { data: topicsData = [], isFetching: isDocsTopicsFetching } =
    useDocsTopicsQuery({
      staleTime: Infinity,
    });

  const {
    data: appealTopicsData = [],
    isFetching: isDocsAppealTopicsFetching,
  } = useDocsAppealTopicsQuery({
    staleTime: Infinity,
  });

  return (
    <Card
      heading="Дополнительно"
      icon={<AdditionallyIcon />}
      expanded={expanded}
      handleExpanded={handleExpanded}
    >
      <AdditionallyBody
        form={form}
        isFetchingComment={isFetching}
        lastComment={lastComment}
        statuses={statuses}
        isFetchingStatuses={isFetchingStatuses}
        topicsData={topicsData}
        isDocsTopicsFetching={isDocsTopicsFetching}
        appealTopicsData={appealTopicsData}
        isDocsAppealTopicsFetching={isDocsAppealTopicsFetching}
      />
    </Card>
  );
};

export default AdditionallyContainer;
